import { render, staticRenderFns } from "./questionForm.vue?vue&type=template&id=398c72cc&scoped=true"
import script from "./questionForm.vue?vue&type=script&lang=js"
export * from "./questionForm.vue?vue&type=script&lang=js"
import style0 from "./questionForm.vue?vue&type=style&index=0&id=398c72cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c72cc",
  null
  
)

export default component.exports